import { render, staticRenderFns } from "./OperaLabelsWindow.vue?vue&type=template&id=3753913b&scoped=true&"
import script from "./OperaLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsWindow.vue?vue&type=style&index=0&id=3753913b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753913b",
  null
  
)

export default component.exports